import "./Questions.css";
import plus from "../img/icon-plus.svg";
import minus from "../img/icon-minus.svg";
import { useState } from "react";

const Questions = ({ heading, explanation }) => {
  const [show, setShow] = useState(false);

  return (
    <section className="component-wrapper">
      <div className="component-heading">
        <h2 onClick={() => setShow(!show)}>{heading}</h2>
        <img src={show ? minus : plus} alt="" />
      </div>
      {show && <p className="paragraph">{explanation}</p>}
    </section>
  );
};

export default Questions;
